var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'design-tag',
    'collapse-tag',
    _vm.form.editing === _vm.field.uuid ? 'editing' : ''
  ],on:{"click":_vm.onToggle}},[_c('SvgIcon',{staticClass:"collapse-tag-icon",attrs:{"name":(_vm.field.options || {}).collapse ? 'plus-square' : 'minus-square'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }